/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {LoaderEvent} from "@nolimitcity/slot-game/bin/core/resource/event/LoaderEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {IceIceYetiGameAssets} from "./IceIceYetiGameAssets";
import {IceIceYetiGameConfig} from "./IceIceYetiGameConfig";
import {IceIceYetiGameModuleConfig} from "./IceIceYetiGameModuleConfig";

require("../../node_modules/gsap/src/uncompressed/plugins/PixiPlugin");

export class IceIceYeti extends SlotGame {

    private static ANIMATIONS_TO_PRELOAD:string[] = [
        "W/wildLand/W_land_", IceIceYetiGameAssets.WILD_PRESENTATION_01,
        IceIceYetiGameAssets.BIG_WIN_EXPLOSION, IceIceYetiGameAssets.BIG_WIN_YETI
    ];

    constructor() {
        super(IceIceYetiGameModuleConfig.instance);
    }

    protected onInitResourcesLoaded(event:LoaderEvent):void {
        if(event.key == ResourcesGroupName.MAIN) {
            const layer:ScalableLayer = StageManager.getLayer(IceIceYetiGameConfig.instance.LAYERS.HIDDEN.name);
            const preloadTimeline:TimelineLite = new TimelineLite({onComplete : () => this.onPreloadComplete()});
            for(let i:number = 0; i < IceIceYeti.ANIMATIONS_TO_PRELOAD.length; i++) {
                let animation:TimelineSprite = new TimelineSprite(GameResources.getTextures(IceIceYeti.ANIMATIONS_TO_PRELOAD[i]));
                layer.addChild(animation);
                preloadTimeline.add(animation.getAnimationAutoShowHide());
            }
        }
        super.onInitResourcesLoaded(event);
    }

    private onPreloadComplete():void {
        StageManager.getLayer(IceIceYetiGameConfig.instance.LAYERS.HIDDEN.name).removeChildren();
    }

    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "M1",
                    "M1",
                    "M1",
                    "L3",
                    "L1",
                    "L2",
                    "L4",
                    "L4",
                    "M4"
                ],
                [
                    "M2",
                    "L1",
                    "M1",
                    "M1",
                    "M3",
                    "M3",
                    "L2",
                    "M1",
                    "M1"
                ],
                [
                    "M4",
                    "L4",
                    "L3",
                    "L1",
                    "L3",
                    "L5",
                    "M3",
                    "M3",
                    "M3"
                ],
                [
                    "M4",
                    "M4",
                    "M4",
                    "M2",
                    "M2",
                    "M1",
                    "M1",
                    "L4",
                    "L2"
                ],
                [
                    "M4",
                    "M4",
                    "M4",
                    "L2",
                    "L5",
                    "L1",
                    "L3",
                    "L3",
                    "L2"
                ]
            ],
            "activeGameAreaBeforeSpin": [
                [
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    false
                ]
            ],
            "activeGameAreaAfterSpin": [
                [
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    false
                ]
            ],
            "overlayWildsBeforeSpin": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "overlayWildsAfterSpin": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "wildInfoList": [],
            "respinTriggeredThisSpin": false,
            "playedBetValue": 1,
            "overlaySymbolsBeforeSpin": [
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ]
            ],
            "overlaySymbolsAfterSpin": [
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ]
            ],
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "nearWinReelsIntense": [
                false,
                false,
                false,
                false,
                false
            ],
            "randomFeatureTriggered": false
        };
    }
}